<div class="px-4 sm:px-6 lg:!px-0 flex flex-col space-y-4">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="font-semibold leading-6 text-gray-900 !text-3xl">Automations-Manager</h1>
    </div>
  </div>
  <div class="absolute inset-8 flex flex-col gap-x-3">
    <div class="absolute inset-0 lg:hidden flex">
      <span class="text-2xl m-auto text-center">Nicht verfügbar, Bildschirmbreite nicht ausreichend.</span>
    </div>
    <div class="absolute inset-0 top-4 hidden lg:block">
      <div class="border-b border-gray-200 h-14">
        <div class="sm:flex sm:items-baseline">
          <h2 class="text-base font-semibold leading-6 text-gray-900">Automationen</h2>
          <div class="mt-4 sm:ml-10 sm:mt-0">
            <nav class="-mb-px flex space-x-8">
              <!-- Current: "border-theme-primary-900 text-theme-primary-700", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
              @if (filteredSchedulerItems) {
                <a
                  class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 whitespace-nowrap border-b-2 px-1 pb-1 text-sm font-medium cursor-pointer select-none"
                  [ngClass]="{'border-theme-primary-700 text-theme-primary-700 hover:text-theme-primary-900': selectedObjectType == SchedulerObjectType.Item}"
                  (click)="selectedObjectType = SchedulerObjectType.Item;selectedSchedulerGroup = undefined">Single</a>
              }
              @if (filteredSchedulerGroups) {
                <a (click)="selectedObjectType = SchedulerObjectType.Group;selectedSchedulerGroup = undefined"
                   [ngClass]="{'border-theme-primary-700 text-theme-primary-700 hover:text-theme-primary-900': selectedObjectType == SchedulerObjectType.Group}"
                   class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 whitespace-nowrap border-b-2 px-1 pb-1 text-sm font-medium cursor-pointer select-none">Multi</a>
              }
            </nav>
          </div>
          <div class="flex space-x-1 place-self-end pb-1 pl-3 ml-auto">
            <input [(ngModel)]="showDisabled" (ngModelChange)="showDisabledChanged()" class="" id="show-inactive"
                   type="checkbox">
            <label class="cursor-pointer select-none" for="show-inactive">Inaktive Automationen anzeigen</label>
          </div>
        </div>
      </div>

      <!--
        The `id` is load-bearing, not decoration (#236): this grid is the `[appendTo]` target for all ten
        <ng-select>s on this page. It qualifies on all three counts — it is already POSITIONED
        (`absolute inset-x-0 bottom-0`, so ng-select's inline offsets resolve against it), it is the PARENT of
        both scrolling columns (`overflow-y-auto` at the list column and at the detail column) that were
        clipping the option lists, and an id is UNIQUE by contract, which a utility-class selector is not.
        This page is not on the `layout-page-container` contract, so there is no `.page-viewport` here.
      -->
      <div class="grid grid-cols-4 p-2 top-14 absolute inset-x-0 bottom-0" id="automation-manager-grid">
        @if (filteredSchedulerGroups && selectedObjectType == SchedulerObjectType.Group) {
          <div class="flex flex-col overflow-y-auto pr-2 relative border-r-2 border-gray-500 space-y-2 p-2">
            @for (group of filteredSchedulerGroups; track group.id) {
              <div>
                <div (click)="selectedSchedulerGroup = selectedSchedulerGroup == group ? undefined : group"
                     [class.border-2]="group == selectedSchedulerGroup"
                     [class.border-theme-primary-700]="group == selectedSchedulerGroup"
                     class="rounded-2xl bg-white shadow-lg flex flex-col p-2 cursor-pointer select-none hover:bg-gray-100">
                  @if (!group.active) {
                    <span class="text-red-600 select-none text-sm font-bold">[ INAKTIV ]</span>
                  } @else if (group.active && showDisabled) {
                    <span class="text-green-700 select-none text-sm font-bold">[ AKTIV ]</span>
                  }
                  <span class="font-bold">{{ eventName(group.additionalIds["EventId"]) }}</span>
                  <span
                    class="font-light text-sm">{{ group.first | date: "dd.MM.yyyy HH:mm" }}{{ (group.schedulerReoccurrence == SchedulerReoccurrence.Reoccurring ? " - " + (group.last | date: 'dd.MM.yyyy HH:mm') : '') }}</span>
                  <span class="font-light text-sm">{{ configurationName(group.additionalIds["ConfigurationId"]) }}</span>
                </div>
              </div>
            }
          </div>
        }
        @if (filteredSchedulerItems && selectedObjectType == SchedulerObjectType.Item) {
          <div class="flex flex-col relative border-r-2 border-gray-500">
          </div>
        }
        @if (selectedSchedulerGroup && events && configurations) {
          <div class="col-span-3 border-l-2 border-gray-300 -ml-px space-y-6 overflow-y-auto p-3">
            <div class="space-y-10 divide-y divide-gray-900/10">
              <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                <div class="px-4 sm:px-0">
                  <div class="w-full py-2 flex">
                    @if (selectedSchedulerGroup.active) {
                      <span (click)="deleteSchedulerGroup()"
                            class="text-red-600 hover:text-red-800 cursor-pointer select-none">
                        Löschen
                      </span>
                    } @else {
                      <span class="text-red-600 select-none">[ INAKTIV ]</span>
                    }
                  </div>
                  <p><span class="font-bold">ID:</span> {{ selectedSchedulerGroup.id }}</p>
                  <p><span
                    class="font-bold">Event:</span> {{ eventName(selectedSchedulerGroup.additionalIds["EventId"]!) }}
                  </p>
                  <p><span
                    class="font-bold">Preisprofil:</span> {{ configurationName(selectedSchedulerGroup.additionalIds["ConfigurationId"]!) }}
                  </p>
                  <p><span class="font-bold">Start:</span> {{ selectedSchedulerGroup.first | date: "dd.MM.yyyy HH:mm" }}
                    Uhr</p>
                  @if (selectedSchedulerGroup.schedulerReoccurrence == SchedulerReoccurrence.Reoccurring) {
                    <p>
                      <span class="font-bold">Ende:</span>
                      {{ selectedSchedulerGroup.last | date: "dd.MM.yyyy HH:mm" }} Uhr
                    </p>
                    <p>
                      <span class="font-bold">Intervall:</span>
                      {{ selectedSchedulerGroup.interval / 60 }} Minute(n)
                    </p>
                  }

                  <p><span
                    class="font-bold">Sortierung:</span> {{ getTypeOrderName(selectedSchedulerGroup.typeOrder!) }}
                  </p>
                  <p><span
                    class="font-bold">Objekttyp:</span> {{ getCalculationTargetTypeName(selectedSchedulerGroup.calculationTargetType!) }}
                  </p>
                  <p><span
                    class="font-bold">Berechnugnsziel:</span> {{ getCalculationTypeName(selectedSchedulerGroup.schedulerItems[0].calculationType!) }}
                  </p>
                  <p><span
                    class="font-bold">Berechnung:</span> {{ getCalculationOperationName(selectedSchedulerGroup.schedulerItems[0].calculationOperation!) }}
                  </p>
                  <p><span
                    class="font-bold">Runden:</span> {{ getRoundingType(selectedSchedulerGroup.schedulerItems[0].roundingType) }}
                  </p>
                </div>

                <div class="bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2 max-w-2xl">
                  @if (selectedSchedulerGroup.calculationTargetType == CalculationTargetType.Composition && compositions) {
                    <div class="px-4 py-2 space-y-2">
                      @for (item of selectedSchedulerGroup.schedulerItems; track item.id) {
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-3">
                            <label class="block text-sm font-medium leading-6 text-gray-900"
                                   for="target_{{ item.id }}">Objekt</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <input [value]="compositionName(item.calculationTargetId)"
                                       class="w-full p-1 border-gray-300 border-2 rounded-md" disabled
                                       id="target_{{ item.id }}"
                                       type="text">
                              </div>
                            </div>
                          </div>
                          <div class="sm:col-span-3">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="value_{{ item.id }}">Zuordnungswert</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <!--
                                  #448: the item's OWN value, never `calculationValues[$index]`. The parallel
                                  array is indexed by the order the user attached the values in, while the items
                                  arrive in whatever order EF materialised the navigation — so pairing them by
                                  row position showed each target somebody else's value, differently on every
                                  reload. `calculationValue` is persisted per item and normalised server-side by
                                  `SchedulerGroupDto`.
                                -->
                                <input [value]="item.calculationValue"
                                       class="w-full p-1 border-gray-300 border-2 rounded-md" disabled
                                       id="value_{{ item.id }}"
                                       type="number">
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (selectedSchedulerGroup.calculationTargetType == CalculationTargetType.CompositionType && compositionTypes) {
                    <div class="px-4 py-2 space-y-2">
                      @for (item of selectedSchedulerGroup.schedulerItems; track item.id) {
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-3">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="target_{{ item.id }}">Artikel-Kategorie</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <input [value]="compositionTypeName(item.calculationTargetId)"
                                       class="w-full p-1 border-gray-300 border-2 rounded-md" disabled
                                       id="target_{{ item.id }}"
                                       type="text">
                              </div>
                            </div>
                          </div>
                          <div class="sm:col-span-3">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="value_{{ item.id }}">Zuordnungswert</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <!-- #448 — see the composition branch above: the item's own value, not a
                                     parallel array indexed by row position. -->
                                <input [value]="item.calculationValue"
                                       class="w-full p-1 border-gray-300 border-2 rounded-md" disabled
                                       id="value_{{ item.id }}"
                                       type="number">
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              @if (selectedSchedulerGroup.active) {
                <div class="w-full pt-2 flex flex-col">
                  <span class="text-theme-primary-900">Verfügbare Ansichten</span>
                  @if (selectedSchedulerGroup.schedulerItems.length > 0 && selectedSchedulerGroup.typeOrder == TypeOrder.Count && selectedSchedulerGroup.calculationTargetType == CalculationTargetType.Composition && selectedSchedulerGroup.schedulerItems[0].calculationType == CalculationType.CalculationAlternativePrice) {
                    <div class="flex w-full space-x-4">
                      <a
                        [href]="'/' + Routes.AutomationModule + '/' + AutomationRoutes.ViewStockMarket + '?schedulergroup=' + selectedSchedulerGroup.id"
                        class="text-gray-500 hover:text-gray-800 hover:underline cursor-pointer select-none"
                        target="_blank">
                        Stock Market
                      </a>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }


        @if (schedulerGroups && selectedObjectType == SchedulerObjectType.Group && newSchedulerGroup && events && configurations && !selectedSchedulerGroup) {
          <div class="col-span-3 border-l-2 border-gray-300 -ml-px space-y-6 overflow-y-auto p-3">
            @if (!setItems()) {
              <div class="space-y-10 divide-y divide-gray-900/10">
                <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                  <div class="px-4 sm:px-0">
                    <h2 class="text-base font-semibold leading-7 text-gray-900">Event</h2>
                  </div>

                  <div class="max-w-2xl bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                    <div class="px-4 py-2">
                      <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div class="sm:col-span-6">
                          <!--
                            `for` must name the INNER input `ng-select` renders, not the host element (a
                            custom element is not labelable) — `labelForId` is ng-select's hook for that
                            (#236, style-guide.md). `id="event"` stays on the host: it is the `By.css`/DOM
                            selector the #236 portaling tests key on.
                          -->
                          <label class="block text-sm font-medium leading-6 text-gray-900"
                                 for="event_input">Ziel-Event</label>
                          <div class="">
                            <div
                              class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                              <ng-select [(ngModel)]="newSchedulerGroup.additionalIds['EventId']" [items]="selectableEvents ?? []"
                                         bindLabel="name" bindValue="id" class="w-full"
                                         appendTo="#automation-manager-grid" id="event"
                                         labelForId="event_input">

                              </ng-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              @if (isVisible(NewGroupStep.Configuration)) {
                <div class="space-y-10 divide-y divide-gray-900/10">
                  <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                    <div class="px-4 sm:px-0">
                      <h2 class="text-base font-semibold leading-7 text-gray-900">Preisprofil</h2>
                    </div>

                    <div class="max-w-2xl bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                      <div class="px-4 py-2">
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-6">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="configuration_input">Ziel-Preisprofil</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <ng-select [(ngModel)]="newSchedulerGroup.additionalIds['ConfigurationId']"
                                           [items]="configurations" bindLabel="name" bindValue="id"
                                           class="w-full" appendTo="#automation-manager-grid" id="configuration"
                                           labelForId="configuration_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              @if (isVisible(NewGroupStep.Reoccurrence)) {
                <div class="space-y-10 divide-y divide-gray-900/10">
                  <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                    <div class="px-4 sm:px-0">
                      <h2 class="text-base font-semibold leading-7 text-gray-900">Wiederholung</h2>
                      <ul class="mt-1 text-sm leading-6 text-gray-600 list-disc">
                        <li><span class="font-bold">Einmalig:</span> Ausführung zum Startzeitpunkt</li>
                        <li><span class="font-bold">Intervall:</span> Ausführung alle X Minuten nach dem Startzeitpunkt
                          bis
                          zum Endzeitpunkt
                        </li>
                      </ul>
                    </div>

                    <div class="max-w-2xl bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                      <div class="px-4 py-2">
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-6">
                            <label class="block text-sm font-medium leading-6 text-gray-900"
                                   for="schedulerReoccurrence_input">Wiederholung</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <ng-select [(ngModel)]="newSchedulerGroup.schedulerReoccurrence"
                                           [items]="schedulerReoccurrence" bindLabel="name"
                                           bindValue="id" class="w-full"
                                           appendTo="#automation-manager-grid" id="schedulerReoccurrence"
                                           labelForId="schedulerReoccurrence_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              @if (isVisible(NewGroupStep.Time)) {
                <div class="space-y-10 divide-y divide-gray-900/10">
                  <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                    <div class="px-4 sm:px-0">
                      <h2 class="text-base font-semibold leading-7 text-gray-900">Zeiteinstellungen</h2>
                    </div>

                    <div class="max-w-2xl bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                      <div class="px-4 py-2">
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div
                            [class.sm:col-span-6]="newSchedulerGroup.schedulerReoccurrence == SchedulerReoccurrence.Once"
                            class="sm:col-span-3">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="first">Start</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <input [(ngModel)]="newSchedulerGroup.firstStr"
                                       class="w-full px-2 py-1 border-gray-300 rounded-md border-2"
                                       id="first" type="datetime-local">
                              </div>
                            </div>
                          </div>
                          @if (newSchedulerGroup.schedulerReoccurrence == SchedulerReoccurrence.Reoccurring) {
                            <div class="sm:col-span-3">
                              <label class="block text-sm font-medium leading-6 text-gray-900" for="last">Ende</label>
                              <div class="">
                                <div
                                  class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                  <input [(ngModel)]="newSchedulerGroup.lastStr"
                                         class="w-full px-2 py-1 border-gray-300 rounded-md border-2"
                                         id="last" type="datetime-local">
                                </div>
                              </div>
                            </div>
                            <div class="sm:col-span-6">
                              <label class="block text-sm font-medium leading-6 text-gray-900" for="interval">Interval
                                (in
                                Minuten)</label>
                              <div class="">
                                <div
                                  class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                  <input [(ngModel)]="newSchedulerGroup.interval"
                                         class="w-full px-2 py-1 border-gray-300 rounded-md border-2" id="interval"
                                         step="1" type="number">
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              @if (isVisible(NewGroupStep.Sorting)) {
                <div class="space-y-10 divide-y divide-gray-900/10">
                  <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                    <div class="px-4 sm:px-0">
                      <h2 class="text-base font-semibold leading-7 text-gray-900">Sortiereinstellungen</h2>
                      <ul class="mt-1 text-sm leading-6 text-gray-600 list-disc">
                        <li><span class="font-bold">Keine:</span> Elemente sind Werten zugeordnet.</li>
                        <li><span class="font-bold">Anzahl:</span> Sortiert nach der Anzahl der verkauften Getränke
                          während
                          des Events
                        </li>
                      </ul>
                    </div>

                    <div class="max-w-2xl bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                      <div class="px-4 py-2">
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-6">
                            <label class="block text-sm font-medium leading-6 text-gray-900"
                                   for="typeOrder_input">Sortierung</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <ng-select [(ngModel)]="newSchedulerGroup.typeOrder" [items]="typeOrder"
                                           bindLabel="name"
                                           bindValue="id" class="w-full"
                                           appendTo="#automation-manager-grid" id="typeOrder"
                                           labelForId="typeOrder_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              @if (isVisible(NewGroupStep.Target)) {
                <div class="space-y-10 divide-y divide-gray-900/10">
                  <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                    <div class="px-4 sm:px-0">
                      <h2 class="text-base font-semibold leading-7 text-gray-900">Zielobjekteinstellungen</h2>
                      <ul class="mt-1 text-sm leading-6 text-gray-600 list-disc">
                        <li><span class="font-bold">Artikel:</span> Getränke, Speisen, ...</li>
                      </ul>
                    </div>

                    <div class="max-w-2xl bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                      <div class="px-4 py-2">
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-6">
                            <label class="block text-sm font-medium leading-6 text-gray-900"
                                   for="targetType_input">Zielobjekt</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <ng-select [(ngModel)]="newSchedulerGroup.calculationTargetType"
                                           [items]="calculationTargetType" bindLabel="name" bindValue="id"
                                           class="w-full" appendTo="#automation-manager-grid" id="targetType"
                                           labelForId="targetType_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              @if (isVisible(NewGroupStep.Calculations)) {
                <div class="space-y-10 divide-y divide-gray-900/10">
                  <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                    <div class="px-4 sm:px-0">
                      <h2 class="text-base font-semibold leading-7 text-gray-900">Berechnungseinstellungen</h2>
                      <ul class="mt-1 text-sm leading-6 text-gray-600 list-disc">
                        <li><span class="font-bold">Berechnungsziel:</span> Speicherort des berechneten Wertes</li>
                        <li><span class="font-bold">Berechnungsoperation:</span> Berechnungsart des Werts. Wenn eine
                          Sortierung angegeben wurde sind die Werte losgelöst vom Objekt.
                        </li>
                        <li><span class="font-bold">Rundungseinstellungen:</span> Runden auf ganze 10ct. oder volle
                          Euro.
                        </li>
                      </ul>
                    </div>

                    <div class="max-w-2xl bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                      <div class="px-4 py-2">
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-3">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="calculationType_input">Berechnungsziel</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <ng-select [(ngModel)]="newSchedulerGroup.calculationType" [items]="calculationType"
                                           bindLabel="name" bindValue="id"
                                           class="w-full" appendTo="#automation-manager-grid" id="calculationType"
                                           labelForId="calculationType_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                          <div class="sm:col-span-3">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="calculationOperation_input">Berechnungsoperation</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <ng-select [(ngModel)]="newSchedulerGroup.calculationOperation"
                                           [items]="calculationOperation"
                                           bindLabel="name"
                                           bindValue="id" class="w-full"
                                           appendTo="#automation-manager-grid" id="calculationOperation"
                                           labelForId="calculationOperation_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                          <div class="sm:col-span-6">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="roundingType_input">Rundungsoptionen</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <ng-select [(ngModel)]="newSchedulerGroup.roundingType" [items]="roundingType"
                                           bindLabel="name" bindValue="id"
                                           class="w-full" appendTo="#automation-manager-grid" id="roundingType"
                                           labelForId="roundingType_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                          <div class="sm:col-span-6 flex">
                            @if (setItems(false)) {
                              <button (click)="continue = true"
                                      class="ml-auto px-3 py-2 rounded-md bg-theme-primary-700 hover:bg-theme-primary-900 cursor-pointer select-none text-white">
                                Weiter
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            } @else {
              <!-- set items -->
              <div class="space-y-10 divide-y divide-gray-900/10">
                <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
                  <div class="px-4 sm:px-0">
                    <h2
                      (click)="continue = false;"
                      class="text-base font-semibold leading-7 text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer select-none">
                      Zurück</h2>
                    <p><span
                      class="font-bold">Event:</span> {{ eventName(newSchedulerGroup.additionalIds["EventId"]!) }}
                    </p>
                    <p><span
                      class="font-bold">Preisprofil:</span> {{ configurationName(newSchedulerGroup.additionalIds["ConfigurationId"]!) }}
                    </p>
                    <p><span class="font-bold">Start:</span> {{ newSchedulerGroup.first | date: "dd.MM.yyyy HH:mm" }}
                      Uhr
                    </p>

                    @if (newSchedulerGroup.schedulerReoccurrence == SchedulerReoccurrence.Reoccurring) {
                      <p>
                        <span class="font-bold">Ende:</span>
                        {{ newSchedulerGroup.last | date: "dd.MM.yyyy HH:mm" }} Uhr
                      </p>
                      <p>
                        <span class="font-bold">Intervall:</span>
                        {{ newSchedulerGroup.interval }} Minute(n)
                      </p>
                    }
                    <p><span class="font-bold">Sortierung:</span> {{ getTypeOrderName(newSchedulerGroup.typeOrder!) }}
                    </p>
                    <p><span
                      class="font-bold">Objekttyp:</span> {{ getCalculationTargetTypeName(newSchedulerGroup.calculationTargetType!) }}
                    </p>
                    <p><span
                      class="font-bold">Berechnugnsziel:</span> {{ getCalculationTypeName(newSchedulerGroup.calculationType!) }}
                    </p>
                    <p><span
                      class="font-bold">Berechnung:</span> {{ getCalculationOperationName(newSchedulerGroup.calculationOperation!) }}
                    </p>
                    <p><span class="font-bold">Runden:</span> {{ getRoundingType(newSchedulerGroup.roundingType) }}</p>
                  </div>

                  <div class="max-w-2xl bg-white shadow-2xl ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                    @if (newSchedulerGroup.calculationTargetType == CalculationTargetType.Composition && compositions) {
                      <div class="px-4 py-2 space-y-2">
                        @for (composition of newSchedulerGroup.targetIds; track $index) {
                          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div class="sm:col-span-3">
                              <label class="block text-sm font-medium leading-6 text-gray-900"
                                     for="target_{{ composition }}">Objekt</label>
                              <div class="">
                                <div
                                  class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                  <input [value]="compositionName(composition)"
                                         class="w-full p-1 border-gray-300 border-2 rounded-md" disabled
                                         id="target_{{ composition }}"
                                         type="text">
                                </div>
                              </div>
                            </div>
                            <div class="sm:col-span-2">
                              <label class="block text-sm font-medium leading-6 text-gray-900"
                                     for="value_{{ composition }}">Zuordnungswert</label>
                              <div class="">
                                <div
                                  class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                  <input [(ngModel)]="newSchedulerGroup.calculationValues[$index]"
                                         [value]="compositionName(composition)"
                                         class="w-full p-1 border-gray-300 border-2 rounded-md"
                                         id="value_{{ composition }}"
                                         type="number">
                                </div>
                              </div>
                            </div>
                            <div class="sm:col-span-1">
                              <span class="block text-sm font-medium leading-6 text-gray-900">&nbsp;</span>
                              <div class="">
                                <div
                                  class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                          <span (click)="removeComposition($index)"
                                class="m-auto text-red-600 hover:text-red-800 cursor-pointer select-none p-1">Entfernen</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-6">
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="addComposition_input">Objekt
                              hinzufügen</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <!-- Assign FIRST, then handle: `addComposition` resets `selectedComposition` to
                                     null so the picker clears after adding. With `[(ngModel)]` + a second
                                     (ngModelChange) the generated assignment ran AFTER the handler and put the
                                     just-picked item straight back in (#267). -->
                                <ng-select (ngModelChange)="selectedComposition = $event; addComposition($event)"
                                           [ngModel]="selectedComposition"
                                           [items]="compositions" bindLabel="name"
                                           bindValue="id" class="w-full"
                                           appendTo="#automation-manager-grid" id="addComposition"
                                           labelForId="addComposition_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                          <div class="sm:col-span-6 flex">
                            <button
                              (click)="sendSchedulerGroup()"
                              class="ml-auto flex py-1 px-2 bg-theme-primary-700 hover:bg-theme-primary-900 select-none cursor-pointer text-white rounded-2xl">
                              Speichern
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                    @if (newSchedulerGroup.calculationTargetType == CalculationTargetType.CompositionType && compositionTypes) {
                      <div class="px-4 py-2 space-y-2">
                        @for (compositionType of newSchedulerGroup.targetIds; track $index) {
                          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div class="sm:col-span-3">
                              <label class="block text-sm font-medium leading-6 text-gray-900"
                                     for="target_{{ compositionType }}">Artikel-Kategorie</label>
                              <div class="">
                                <div
                                  class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                  <input [value]="compositionTypeName(compositionType)"
                                         class="w-full p-1 border-gray-300 border-2 rounded-md" disabled
                                         id="target_{{ compositionType }}"
                                         type="text">
                                </div>
                              </div>
                            </div>
                            <div class="sm:col-span-2">
                              <label class="block text-sm font-medium leading-6 text-gray-900"
                                     for="value_{{ compositionType }}">Zuordnungswert</label>
                              <div class="">
                                <div
                                  class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                  <input [(ngModel)]="newSchedulerGroup.calculationValues[$index]"
                                         [value]="compositionTypeName(compositionType)"
                                         class="w-full p-1 border-gray-300 border-2 rounded-md"
                                         id="value_{{ compositionType }}"
                                         type="number">
                                </div>
                              </div>
                            </div>
                            <div class="sm:col-span-1">
                              <span class="block text-sm font-medium leading-6 text-gray-900">&nbsp;</span>
                              <div class="">
                                <div
                                  class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                          <span (click)="removeComposition($index)"
                                class="m-auto text-red-600 hover:text-red-800 cursor-pointer select-none p-1">Entfernen</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                          <div class="sm:col-span-6">
                            <!--
                              #236 audit: this label used to say `for="addComposition"` — the OTHER picker's
                              id (the composition-target select above, not this composition-*type* select) —
                              so it named the wrong control entirely, on top of not resolving to a focusable
                              element at all. Fixed to name this select's own `labelForId`.
                            -->
                            <label class="block text-sm font-medium leading-6 text-gray-900" for="addCompositionType_input">Artikel-Kategorie
                              hinzufügen</label>
                            <div class="">
                              <div
                                class="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-theme-primary-900">
                                <!-- Assign first, then handle — see the composition picker above (#267). -->
                                <ng-select (ngModelChange)="selectedCompositionType = $event; addCompositionType($event)"
                                           [ngModel]="selectedCompositionType"
                                           [items]="compositionTypes" bindLabel="name"
                                           bindValue="id" class="w-full"
                                           appendTo="#automation-manager-grid" id="addCompositionType"
                                           labelForId="addCompositionType_input">

                                </ng-select>
                              </div>
                            </div>
                          </div>
                          <div class="sm:col-span-6 flex">
                            <button
                              (click)="sendSchedulerGroup()"
                              class="ml-auto flex py-1 px-2 bg-theme-primary-700 hover:bg-theme-primary-900 select-none cursor-pointer text-white rounded-2xl">
                              Speichern
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
